import { render, staticRenderFns } from "./DescriptionPopup.vue?vue&type=template&id=0b06288c&scoped=true"
import script from "./DescriptionPopup.vue?vue&type=script&lang=js"
export * from "./DescriptionPopup.vue?vue&type=script&lang=js"
import style0 from "./DescriptionPopup.vue?vue&type=style&index=0&id=0b06288c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06288c",
  null
  
)

export default component.exports